import { IRenderFn } from "@/utils/types";
import editIconLightMode from "@/assets/img/edit-black.svg";
import style from "./EditCell.component.module.scss";
import { renderCell, ICellEvents, ICellProps } from "./Cell.component";

const iconSrc = editIconLightMode;

type IEditCellProps = Pick<
  ICellProps,
  "isCellSelected" | "isBottomCellSelected" | "isTopCellSelected"
> & { index: number; isFirstColumn: boolean };

type NewType = ICellEvents;

export const renderEditCell: IRenderFn<IEditCellProps, NewType> = (
  h,
  { props, listeners, data },
) =>
  renderCell(h, {
    props: {
      ...props,
      dataTestId: `row${props.index}Edit`,
      isLeftCellSelected: true,
      isRightCellSelected: true,
      isFirstDataColumn: false,
      isPrevCellSelection: false,
    },
    children: <img src={iconSrc} class={style.icon} />,
    listeners,
    data: {
      ...data,
      class: {
        [style.cell]: true,
        [style.selected]: props.isCellSelected,
        [style.topSelected]: props.isTopCellSelected,
        [style.bottomSelected]: props.isBottomCellSelected,
        [style.isFirstColumn]: props.isFirstColumn,
      },
    },
  });
